import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { useListFilterContext, useTranslate } from 'react-admin';

const noteTypeFilterName = 'type-item';

const NotesFilters: React.FC = () => {
    const t = useTranslate();
    const { displayedFilters, setFilters, filterValues } = useListFilterContext();

    const addFilter = (key: string, value: string) => {
        setFilters({ ...filterValues, [key]: value }, displayedFilters);
    };

    const removeFilter = (key: string) => {
        const newFilters: any = { ...filterValues };
        delete newFilters[key];
        setFilters(newFilters, displayedFilters);
    };

    const noteTypeNoteFilterState = useMemo(
        () => noteTypeFilterName in filterValues && filterValues[noteTypeFilterName] === 'note',
        [filterValues],
    );

    const noteTypeTraceabilityFilterState = useMemo(
        () => noteTypeFilterName in filterValues && filterValues[noteTypeFilterName] === 'traceability',
        [filterValues],
    );

    const handleNoteFilterChange = () => {
        if (noteTypeNoteFilterState) {
            addFilter(noteTypeFilterName, 'traceability');
        } else {
            if (noteTypeTraceabilityFilterState) {
                removeFilter(noteTypeFilterName);
            } else {
                addFilter(noteTypeFilterName, 'traceability');
            }
        }
    };

    const handleTraceabilityNoteFilterChange = () => {
        if (noteTypeTraceabilityFilterState) {
            addFilter(noteTypeFilterName, 'note');
        } else {
            if (noteTypeNoteFilterState) {
                removeFilter(noteTypeFilterName);
            } else {
                addFilter(noteTypeFilterName, 'note');
            }
        }
    };

    return (
        <Box
            style={{
                background: '#f8fafc',
                padding: '10px 16px',
                borderBottom: '1px solid #e3e8ee',
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, auto)',
                justifyContent: 'start',
                alignItems: 'center',
                gap: 8,
                width: '100%',
            }}
        >
            <Typography
                style={{
                    color: '#3b4a5a',
                    fontSize: 14,
                    fontWeight: 600,
                }}
            >
                {t('app.objects.info.filter.filter') || 'Type'}
            </Typography>

            <Chip
                label={t('app.objects.info.filter.note') || 'Note'}
                onClick={handleNoteFilterChange}
                style={{
                    height: 28,
                    fontSize: 13,
                    fontWeight: 500,
                }}
                {...(((noteTypeNoteFilterState && !noteTypeTraceabilityFilterState) ||
                    (!noteTypeNoteFilterState && !noteTypeTraceabilityFilterState)) && { color: 'primary' as any })}
            />

            <Chip
                label={t('app.objects.info.filter.traceability') || 'Traceability'}
                onClick={handleTraceabilityNoteFilterChange}
                style={{
                    height: 28,
                    fontSize: 13,
                    fontWeight: 500,
                }}
                {...(((!noteTypeNoteFilterState && noteTypeTraceabilityFilterState) ||
                    (!noteTypeNoteFilterState && !noteTypeTraceabilityFilterState)) && { color: 'primary' as any })}
            />
        </Box>
    );
};

export default NotesFilters;
